/** Téléchargement générique (CSV, JSON, etc.) — même logique que l’onglet Admin « Import ». */
export function downloadTextFile(filename, content, mime = 'text/csv;charset=utf-8') {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function csvEscapeCell(value) {
  const s = String(value ?? '');
  if (s.includes('"') || s.includes(',') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function buildCsvFromRows(headers, rows) {
  const lines = [headers, ...rows].map((row) => row.map(csvEscapeCell).join(','));
  return lines.join('\n');
}

/**
 * Modèle Membres — aligné sur `AdminDashboard` (Import de données) :
 * requis : name, email, phone, role, join_date
 * optionnels : status, commission
 */
export function downloadMembersImportTemplate() {
  const headers = ['name', 'email', 'phone', 'role', 'join_date', 'status', 'commission'];
  const rows = [
    [
      'Jean Ndayisaba',
      'jean@example.com',
      '+25779000111',
      'participant',
      '2026-04-01',
      'active',
      'Commission sociale',
    ],
  ];
  downloadTextFile('membres_modele.csv', buildCsvFromRows(headers, rows));
}

/**
 * Modèle Utilisateurs — aligné sur `AdminDashboard` :
 * requis : username, role
 * optionnels : phone, email, name, member_id
 */
export function downloadUsersImportTemplate() {
  const headers = ['username', 'role', 'phone', 'email', 'name', 'member_id'];
  const rows = [['+25779000222', 'participant', '+25779000222', 'alice@example.com', 'Alice Uwimana', '']];
  downloadTextFile('utilisateurs_modele.csv', buildCsvFromRows(headers, rows));
}

/**
 * Modèle Cotisations :
 * - format minimal : member_phone|member_email|member_id + amount (month optionnel => mois courant)
 * - format complet : month/status/payment_method/payment_date/notes/proof_documents
 */
export function downloadContributionsImportTemplate() {
  const headers = [
    'member_phone',
    'member_email',
    'member_id',
    'month',
    'amount',
    'status',
    'payment_method',
    'payment_date',
    'notes',
    'proof_documents',
  ];
  const rows = [
    [
      '+25779000111',
      '',
      '',
      '2026-04',
      '5000',
      'pending',
      'mobile_money',
      '2026-04-28',
      'Versement mensuel',
      'https://files.example/proof-1.jpg',
    ],
    [
      '',
      'jean@example.com',
      '',
      '',
      '5000',
      'completed',
      'virement',
      '',
      'Import minimal: mois courant',
      '',
    ],
  ];
  downloadTextFile('cotisations_modele.csv', buildCsvFromRows(headers, rows));
}
